const testimonials = [
  {
    name: "Sarah Mitchell",
    role: "Fashion Shopper",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20warm%20smile%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-sarah-01&orientation=squarish",
    rating: 5,
    title: "Saved me hours every week",
    content: "I used to spend entire evenings browsing LitBuy, opening dozens of tabs. The LitBuy spreadsheet completely changed my workflow — now I find what I need in minutes. The organized categories make browsing shoes and hoodies so much faster.",
  },
  {
    name: "Marcus Chen",
    role: "Streetwear Enthusiast",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20confident%20expression%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-marcus-01&orientation=squarish",
    rating: 5,
    title: "Best tool for serious shoppers",
    content: "The comparison tables alone are worth it. Being able to see seller ratings and prices side by side for jackets and accessories has helped me avoid bad purchases multiple times. Highly recommend for anyone doing regular hauls.",
  },
  {
    name: "Emily Rodriguez",
    role: "Budget Shopper",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20friendly%20smile%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-emily-01&orientation=squarish",
    rating: 5,
    title: "Game changer for finding deals",
    content: "As someone who shops on a budget, the LitBuy spreadsheet helps me compare prices across sellers instantly. I have found amazing deals on t-shirts and bags that I would have completely missed by searching manually.",
  },
  {
    name: "David Park",
    role: "Reseller",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20thoughtful%20expression%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-david-01&orientation=squarish",
    rating: 4,
    title: "Essential for inventory tracking",
    content: "I manage inventory across multiple categories and the spreadsheet format makes tracking everything so much easier. The seller verification notes have saved me from several questionable suppliers.",
  },
  {
    name: "Jessica Liu",
    role: "Casual Shopper",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20woman%20with%20gentle%20smile%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-jessica-01&orientation=squarish",
    rating: 5,
    title: "Made shopping actually enjoyable",
    content: "I was overwhelmed by LitBuy at first — there are so many products. The spreadsheet organized everything by category so I could focus on what I actually wanted. Now I actually look forward to browsing new drops.",
  },
  {
    name: "Ryan Thompson",
    role: "Fashion Blogger",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20a%20young%20man%20with%20warm%20expression%20natural%20lighting%20cream%20background%20soft%20portrait%20photography%20minimalist%20style&width=120&height=120&seq=avatar-ryan-01&orientation=squarish",
    rating: 4,
    title: "Great for content research",
    content: "As a blogger, I need to stay on top of trends across categories like jerseys, sets, and accessories. The LitBuy spreadsheet helps me spot emerging trends and popular items before they blow up on social media.",
  },
];

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-10 bg-background-200/70">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="flex items-center justify-center gap-2 mb-3">
            <span className="w-2 h-2 rounded-full bg-accent-500" />
            <span className="text-xs text-foreground-500 tracking-widest uppercase font-label">
              Trusted by Users
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            What Our Community<br />
            Says About Us
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            Real feedback from real shoppers who use LitBuy spreadsheets every day.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <div className="flex gap-1 mb-3">
                {Array.from({ length: 5 }).map((_, starIdx) => (
                  <span key={starIdx} className="w-4 h-4 flex items-center justify-center">
                    <i
                      className={`text-sm ${
                        starIdx < t.rating
                          ? 'ri-star-fill text-amber-400'
                          : 'ri-star-line text-foreground-300'
                      }`}
                    />
                  </span>
                ))}
              </div>
              <h4 className="font-heading text-base font-bold text-foreground-900 mb-2">
                {t.title}
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {t.content}
              </p>
              <div className="flex items-center gap-3 pt-3 border-t border-background-200/60">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}